import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";
import dataService from "../../api";


export default {
    namespaced: true,
    state: {
        departments: [],
        department: {
            name: 'احمد', 
            createdBy: null,
            createdOn: null,
            status: 1,
        },
        totalItems: 0,
    },
    getters: {
    },
    mutations: {
     
    },
    actions: {
        async getStatistics() {
            startLoading()
            try {
                const response = await dataService.dashboard.getStatistics();

                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                    return Promise.resolve(response.data);
                } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getAppointmentsByDoctor() {
            startLoading()
            try {
                const response = await dataService.dashboard.getAppointmentsByDoctor();

                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                    return Promise.resolve(response.data.data);
                } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
   
        async getSalesByMonth() {
            startLoading()
            try {
                const response = await dataService.dashboard.getSalesByMonth();

                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                    return Promise.resolve(response.data.data);
                } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
   
     
    },
};
